import { useAssets as useAssetsNative, Asset } from "expo-asset";
import { useEffect, useState } from "react";
import { ImageAssets } from "src/common/assets/images";
import { ImageAssetHandler } from "../utils/image";

const useAssets = (): [
  { [key: string]: Asset } | undefined,
  Error | undefined
] => {
  const [assets, error] = useAssetsNative(ImageAssets);
  const [images, setImages] = useState({});
  useEffect(() => {
    if (assets) {
      const imgs = {};
      assets.forEach((it) => {
        imgs[it.name?.split(".")[0]] = it;
      });
      ImageAssetHandler.getInstance(imgs);
      setImages(imgs);
    }
  }, [assets]);

  return [images, error];
};

export default useAssets;
